import { EURO_CURRENCY } from '@yme/common/constants';
import { setCurrencyRateData } from '@yme/common/redux/common/action';
import { Network } from '@yme/services/network';
export async function getCurrencyRates(endpoint) {
    const response = await Network.get(endpoint);
    const result = response.data;
    return result;
}
export const getGlobalCurrencyRate = (endpoint, nationalCurrencyCode) => {
    return async (dispatch) => {
        const currencyRateEndpoint = `${endpoint}${nationalCurrencyCode}`;
        if (nationalCurrencyCode !== EURO_CURRENCY && currencyRateEndpoint) {
            getCurrencyRates(currencyRateEndpoint)
                .then((data) => {
                dispatch(setCurrencyRateData(data));
            })
                .catch(() => setCurrencyRateData(null));
        }
        else {
            dispatch(setCurrencyRateData({
                currency: EURO_CURRENCY,
                rate: 1,
            }));
        }
    };
};
